<p-toast></p-toast>

<ng-container *ngIf="currentActiveChat || (currentChatType===QECChatType && !activeChat?.chatId && defaultWFDOTables.length)">
    <app-confirmation-dialog [message]="dialogMessage" [display]="displayConfirmationDialog" [type]="displayDialogType"
        (accept)="ondialogaccept()" (cancel)="onCancelDialog()"></app-confirmation-dialog>
    <app-fileupload-metadata-dialog [display]="displayCSVUploadDialog" [CSVFiles]="CSVFilesCopy"
        [tableNames]="CSVTablesData" (accept)="
        this.displayCSVUploadDialog = false;
        submitFileUploadDialog($event);
        this.isdocuploaded = true
    " (cancel)="
        this.displayCSVUploadDialog = false;
        cancelCSVUpload();
        this.CSVTablesData = [];
        this.isloading = false
    "></app-fileupload-metadata-dialog>
    <app-excel-tables-info [display]="displayExcelInfoDialog" (cancel)="closeInFoSlider($event)">
    </app-excel-tables-info>

    <app-document-summary-sidebar *ngIf="dialogType === 'document'" [sidebarVisible]="summaryDialogVisible"
        (emitSidebarUpdate)="updateSidebar($event)" [summaryData]="summaryData" [header]="headerSummary"
        [documentName]="summaryDocumentName" [documentModel]="documentModelForSummary">
    </app-document-summary-sidebar>
    <app-table-summary-sidebar *ngIf="dialogType === 'table'" [sidebarVisible]="summaryDialogVisible"
        (emitSidebarUpdate)="updateSidebar($event)" [summaryData]="summaryData" [header]="headerSummary"
        [documentName]="summaryDocumentName" [deltaTable]="tableSummaryForSidebar"
        [documentModel]="documentModelForSummary">
    </app-table-summary-sidebar>
    <div *ngIf="countDocProcessing>0" class=" my-2 flex justify-content-center align-items-center">
        <P class="processingCounterContainer">
            <span class="loader mt-0 mr-2"></span>
            Uploading {{countDocProcessing}} of {{documentsList?.length}}
        </P>
    </div>

    <div>


        <!-- Logic to handle Vanilla, QEC, User Document Chats -->

        <div class="documentsContainer mt-2"
            *ngIf="currentChatType !== QECChatType && currentChatType !== ESGChatType && currentChatType !== codeInterpreterChatType && currentChatType !== hrDocumentsChatType && currentChatType !== agenticWorkflowChatType && documentsList?.length>0">
            <div *ngIf="currentChatType !== codeInterpreterChatType && currentChatType !== agenticWorkflowChatType; "
                class="header mb-3">
                <span
                    *ngIf="currentChatType !== codeInterpreterChatType && currentChatType !== hrDocumentsChatType">Source
                    files:</span>
                <span *ngIf="currentChatType === hrDocumentsChatType">HR Documents</span>
            </div>

            <!-- Template for displaying Document Status -->
            <ng-template #docUploadStatus let-document="document">
                <div class="ps-2 pe-3 documentsList text-truncate" [ngClass]="
                            document.documentStatus === documentStatusTextOnly
                                ? 'chip-doc-textOnly'
                                : 'chip-new' ">
                    <span [ngClass]="
                    document.documentStatus === documentStatusFailed
                        ? 'reupload'
                        : 'docName'
                " class="docName">
                        <p class="text-truncate mx-2" pTooltip="{{ document.documentName }}" tooltipPosition="top"
                            showDelay="200">
                            {{ document.documentName }}
                        </p>
                    </span>
                    <i *ngIf="
                    document.documentStatus === documentStatusFailed &&
                    !(
                        excelType.includes(document.contentType) ||
                        csvType.includes(document.contentType)
                    )
                " (click)="openRetriggerConfirmation(f, i)" (keydown.enter)="openRetriggerConfirmation(f, i)"
                tabindex="0" role="button" class="bi bi-arrow-clockwise cursor reload mx-2"></i>
                    <i *ngIf="document.documentId !== ''" class="bi bi-x cursor pr-2"
                        (click)="deleteConfirmationDialog(f, i)" (keydown.enter)="deleteConfirmationDialog(f, i)"
                        tabindex="0" role="button"></i>
                </div>
                <div class="mx-2 docStatusTag">
                    <i *ngIf="
                    document.documentStatus === documentStatusFailed ||
                    (document.structuredDocumentStatus &&
                        document.structuredDocumentStatus ===
                            documentStatusFailed)
                " class="bi bi-exclamation-triangle mr-2 text-danger"></i>
                    <i *ngIf="
                    (document.documentStatus === documentStatusActive ) &&
                    (!document.structuredDocumentStatus ||
                        document.structuredDocumentStatus ===
                            documentStatusActive) &&
                    !(
                        excelType.includes(document.contentType) &&
                        !document.structuredDocumentStatus
                    )
                " class="bi bi-check-lg mr-2 text-success"></i>
                    <i *ngIf="
                    document.documentStatus === documentStatusDelete ||
                    document.documentStatus === documentArchived
                " class="pi pi-ban mr-2 text-ban"></i>


                    <i *ngIf="
                    document.documentStatus === documentStatusProcessing || document.documentStatus === documentStatusTextOnly ||
                    document.documentStatus === documentStatusConverting ||
                    (document.structuredDocumentStatus &&
                        document.structuredDocumentStatus ===
                            documentStatusProcessing &&
                        document.documentStatus !==
                            documentStatusDelete) ||
                    (excelType.includes(document.contentType) &&
                        !document.structuredDocumentStatus)" class="bi bi-hourglass mr-2 text-primary"></i>
                </div>
            </ng-template>

            <div *ngIf="documentsList?.length > 0">
                <ng-container *ngIf="isMixedDocumentsPresent; else showAllDocuments">
                    <section class="mixedDocSection">
                        <h2>Structured Files</h2>
                        <div *ngFor="let document of structuredDocumentsList; let i = index; trackBy: trackByDocumentName"
                            class="mt-2 mr-2">
                            <div class="flex">
                                <ng-template
                                    *ngTemplateOutlet="docUploadStatus; context: {document : document} "></ng-template>
                            </div>
                        </div>
                    </section>
                    <section class="mixedDocSection">
                        <h2>UnStructured Files</h2>
                        <div *ngFor="let document of unStructuredDocumentsList; let i = index; trackBy: trackByDocumentName"
                            class="mt-2 mr-2">
                            <div class="flex">
                                <ng-template
                                    *ngTemplateOutlet="docUploadStatus; context: {document : document} "></ng-template>
                            </div>
                        </div>
                    </section>
                </ng-container>
                <ng-template #showAllDocuments>
                    <div *ngFor="let document of documentsList; let i = index; trackBy: trackByDocumentName"
                        class="mt-2 mr-2">
                        <div class="flex">
                            <ng-template
                                *ngTemplateOutlet="docUploadStatus; context: {document : document} "></ng-template>
                        </div>
                    </div>
                </ng-template>

                <div class="imageProcessingStatus" *ngIf="isAnyDocumentImageProcessing">
                    Text Processed, Images Processing
                </div>
            </div>
            
        </div>

        <!-- Template to display ESG / WFDO Chat Tables -->
        <ng-template #tablesBlock let-tableData="tableData">
            <div class="tables-header mt-3 mb-2" [class.collapsible]="tableData?.length > 3" (click)="toggleTablesCollapse(tableData?.length)" (keydown.enter)="toggleTablesCollapse(tableData?.length)" (keydown.space)="toggleTablesCollapse(tableData?.length); $event.preventDefault()" [attr.tabindex]="tableData?.length > 3 ? 0 : null" [attr.role]="tableData?.length > 3 ? 'button' : null" [attr.aria-expanded]="tableData?.length > 3 ? !isTablesCollapsed : null">
                <p class="heading m-0">Tables</p>
                <i *ngIf="tableData?.length > 3" class="bi mobile-collapse-icon" [ngClass]="isTablesCollapsed ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
            </div>
            <div class="flex flex-wrap tables-content" [class.collapsed]="tableData?.length > 3 && isTablesCollapsed">
                <div *ngFor="let f of tableData; let idx=index">
                    <div class="chip-new documentsList mb-2 mr-2">
                        <span class="docName">
                            <i class="bi bi-check mx-2 mt-1"></i>
                            <p class="text-truncate" [pTooltip]="f.tableName" tooltipPosition="top" showDelay="200">
                                {{
                                f.tableName.length > 23
                                ? (f.tableName | slice : 0 : 20) + '...'
                                : f.tableName
                                }}
                            </p>
                        </span>
                        <i *ngIf="!tablesLoaderDocs[idx]" (click)="openSummaryDialog(f,idx)" (keydown.enter)="openSummaryDialog(f,idx)" tabindex="0" role="button" pTooltip="Data dictionary"
                            class="bi bi-table ml-2 cursor iconCSS"></i>
                        <i *ngIf="!tablesLoaderDocs[idx]" (click)="deleteChatTables(f,idx)" (keydown.enter)="deleteChatTables(f,idx)" tabindex="0" role="button"
                            class="bi bi-x mx-2 cursor iconCSS"></i>
                        <div *ngIf="tablesLoaderDocs[idx]" class="mx-2">
                            <span class="loader"></span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Main Section to handle ESG / WFDO Chat Tables & Documents -->

        <div *ngIf="(!isloading
            && (( currentChatType===ESGChatType
                && (activeChat?.ESGTableTags?.length>0
                    || activeChat?.chatConfig?.ESGChat?.ESGSources?.length > 0
                    ||  activeChat?.chatConfig?.ESGChat?.ESGDocuments?.length > 0
                    || activeChat?.chatTables?.length >0 
                    )
                )
                || ( currentChatType===QECChatType
                    && activeChat?.chatTables?.length >0 ) 
                )) || (currentChatType===QECChatType && !activeChat?.chatId && defaultWFDOTables.length)"
            class="card documentsContainer mt-2">
            <div>
                <ng-container *ngIf="activeChat?.ESGTableTags?.length>0">
                    <p class="heading mt-2">Tags</p>
                    <div class="tag-container">
                        <span class="tag" *ngFor="let item of activeChat.ESGTableTags; let idx=index">{{
                            item.tag}}
                            <i *ngIf="!ESGDeletionLoaderTags[idx]" (click)="deleteESGTags(item,idx)"
                                (keydown.enter)="deleteESGTags(item,idx)"
                                class="bi bi-x mx-1 cursor blackIcon"></i>
                            <span *ngIf="ESGDeletionLoaderTags[idx]">
                                <span class="loader my-0 mx-1 loaderGrey"></span>
                            </span>
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="activeChat?.chatConfig?.ESGChat?.ESGSources?.length>0">
                    <p class="heading">Source Type</p>
                    <div class="tag-container">
                        <span class="source"
                            *ngFor="let item of activeChat?.chatConfig?.ESGChat?.ESGSources; let idx=index">
                            {{item.sourceType}}
                            <i *ngIf="!ESGDeletionLoaderSources[idx]" (click)="deleteESGSources(item,idx)"
                                (keydown.enter)="deleteESGSources(item,idx)" tabindex="0" role="button"
                                class="bi bi-x mx-1 cursor blackIcon"></i>
                            <span *ngIf="ESGDeletionLoaderSources[idx]">
                                <span class="loader my-0 mx-1 loaderGrey"></span>
                            </span>
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="activeChat?.chatConfig?.ESGChat?.ESGDocuments?.length>0">
                    <p class="heading mb-2">Documents</p>
                    <div class="flex flex-wrap">
                        <span *ngFor="let item of activeChat?.chatConfig?.ESGChat?.ESGDocuments; let idx=index">
                            <div class="chip-new documentsList mb-2 mr-2">
                                <span class="docName">
                                    <i class="bi bi-check mx-2 mt-1"></i>
                                    <p class="text-truncate" [pTooltip]="item.documentName" tooltipPosition="top"
                                        showDelay="200">
                                        {{
                                        item.documentName.length > 26
                                        ? (item.documentName | slice : 0 : 25) + '..'
                                        : item.documentName
                                        }}
                                    </p>
                                </span>
                                <i *ngIf="!ESGDocumentLoaderDocs[idx]" (click)="openESGSummary(item,idx)"
                                    (keydown.enter)="openESGSummary(item,idx)"
                                    pTooltip="Summary" tooltipPosition="top"
                                    class="bi bi-card-text ml-2 cursor iconCSS"></i>
                                <i *ngIf="!ESGDocumentLoaderDocs[idx]" (click)="deleteChatESGDocs(item,idx)"
                                    (keydown.enter)="deleteChatESGDocs(item,idx)"
                                    class="bi bi-x mx-2 cursor"></i>
                                <div *ngIf="ESGDocumentLoaderDocs[idx]" class="mr-1">
                                    <span class="loader"></span>
                                </div>
                            </div>
                        </span>
                    </div>
                </ng-container>
                <div *ngIf="
                    (currentChatType === QECChatType ||
                        currentChatType === ESGChatType) &&
                    activeChat?.chatTables?.length > 0
                ">
                    <ng-container 
                        *ngTemplateOutlet="tablesBlock;
                        context: { tableData: activeChat.chatTables }"
                    ></ng-container>
                </div>
                <!-- To Handle Default WFDO Tables-->
                <div *ngIf="currentChatType === QECChatType && !activeChat?.chatId && defaultWFDOTables.length">
                    <ng-container 
                        *ngTemplateOutlet="tablesBlock;
                        context: { tableData: defaultWFDOTables }"
                    ></ng-container>
                </div>
            </div>


        </div>

        <!-- Logic to handle Code Interpreter Chats -->

        <div *ngIf="currentChatType === codeInterpreterChatType">

        </div>

        <!-- Logic to handle HR Documents Chats -->

        <div *ngIf="currentChatType === hrDocumentsChatType">
            <div *ngFor="let f of hrDocuments">
                <div class="chip-new documentsList mb-2 mx-2">
                    <span class="docName">
                        <i class="bi bi-check mx-2 mt-1"></i>
                        <p class="text-truncate" [pTooltip]="f.documentName" tooltipPosition="top" showDelay="200">
                            {{
                            f.documentName.length > 38
                            ? (f.documentName | slice : 0 : 35) + '...'
                            : f.documentName
                            }}
                        </p>
                    </span>
                </div>
            </div>
        </div>

    </div>
</ng-container>